import { useColumn } from "../useColumn";

export const useColStatus = () => {
  return useColumn("status", { title: "Status" });
};
